'use strict';

// Error classes

function RegistrationException(message) {
    this.message = message;
    if ("captureStackTrace" in Error)
        Error.captureStackTrace(this, RegistrationException);
    else
        this.stack = (new Error()).stack;
}

RegistrationException.prototype = Object.create(Error.prototype);
RegistrationException.prototype.name = "RegistrationException";
RegistrationException.prototype.constructor = RegistrationException;



function CallException(message) {
    this.message = message;
    if ("captureStackTrace" in Error)
        Error.captureStackTrace(this, CallException);
    else
        this.stack = (new Error()).stack;
}

CallException.prototype = Object.create(Error.prototype);
CallException.prototype.name = "CallException";
CallException.prototype.constructor = CallException;



function NoAccessMicrophoneException(message) {
    this.message = message;
    if ("captureStackTrace" in Error)
        Error.captureStackTrace(this, NoAccessMicrophoneException);
    else
        this.stack = (new Error()).stack;
}

NoAccessMicrophoneException.prototype = Object.create(Error.prototype);
NoAccessMicrophoneException.prototype.name = "NoAccessMicrophoneException";
NoAccessMicrophoneException.prototype.constructor = NoAccessMicrophoneException;
